<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm báo cáo giao hàng</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0 overflow-visible"
                outlined
        >

          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" one-line>
              <v-list-item-content class="overflow-visible pa-0">
                <!--          <v-list-item-title class="headline mb-2">-->
                <!--            Tìm Kiếm-->
                <!--          </v-list-item-title>-->

                <v-row>
                  <v-col cols="12" md="6" class="pl-5">
                    <validation-provider
                            name="Chọn ngày"
                            v-slot="{ errors }"
                            rules="required"
                    >
                      <common-range-picker
                              v-model="selectRange"
                              label="Tìm kiếm theo thời gian"
                              :aLight="'right'"
                              :clearable="true"
                              :defaultRange="defaultRange"
                              @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>

                  <!--tim kiem theo phong ban-->
                  <v-col cols="12" md="6">
                    <!-- <v-autocomplete
                        v-model="filterForm.ministryIds"
                        :items="ministries"
                        item-text="name"
                        item-value="id"
                        label="Tìm kiếm theo bộ phận"
                        placeholder="Bộ phận"
                        color="primary"
                        clearable
                        value=""
                        multiple
                    >

                        <template #prepend-item>
                          <common-select-all
                              v-model="filterForm.ministryIds"
                              :item="filterForm.ministryIds"
                              :items="ministries.map(s => s.id)"
                          ></common-select-all>
                        </template>
                      </v-autocomplete> -->
                    <v-menu
                      bottom
                      offset-y
                      attach
                      content-class="menu-wrapper-tree-user"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            v-if="!filterForm.ministryIds.length"
                            @click="clickSelectUser()">
                          <v-select
                              v-model="filterForm.ministryIds"
                              label="Tìm kiếm theo bộ phận"
                              readonly
                              hide-details
                              placeholder="Bộ phận"
                          >
                          </v-select>
                        </div>
                        <div
                            style="position: relative"
                            v-else
                            v-bind="attrs"
                            v-on="on">
                          <div style="font-size: 10px">Tìm kiếm theo bộ phận</div>
                          <div class="mt-1 tree-user-selected">
                            <span
                                v-for="node in filterForm.ministryIds"
                                :key="node.id"
                            >
                              {{ node.name }}
                            </span>
                          </div>
                          <v-icon
                              class="icon-clear-all"
                              @click="removeOrderSelected()">mdi-close-circle
                          </v-icon>
                        </div>
                      </template>

                      <template>
                        <v-list>
                          <v-text-field
                              class="px-6 py-2"
                              label="Tìm kiếm..."
                              v-model="search"
                              @input="handleSearch"
                          >
                          </v-text-field>

                          <v-treeview
                              v-if="ministries[0].children.length"
                              class="pr-4 pl-3 tree-view-wrapper"
                              v-model="filterForm.ministryIds"
                              selectable
                              :items="ministries"
                              return-object
                              ref="tree"
                              open-on-click
                              :search="search"
                              :open.sync="open"
                              open-all
                          ></v-treeview>
                        </v-list>
                      </template>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <div class="text-right mt-2">
                      <v-btn
                              class="primary mx-0"
                              @click.prevent="handleSubmit(searchReport)"
                      >
                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

              </v-list-item-content>
            </v-list-item>
          </validation-observer>

        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

import { formatDate } from '@/helpers/utils'
import * as moment from 'moment'

export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
    ministries: {
      default: () => ({}),
    }
  },
  data () {
    return {
      defaultRange: {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
      },
      selectRange: [{
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
      }],
      openTree: false,
      search: '',
      open: [1],
      allOpened: false,
      lastOpen: [],
    }
  },
  created() {
    Bus.$on('reset-time-delivery-report', () => {
      this.selectRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
    })
  },
  beforeDestroy() {
    Bus.$off('reset-time-delivery-report')
  },
  methods: {
    searchReport () {
      this.$emit('click-search', this.filterForm)
    },
    changeDateRange (dateRange) {
      this.filterForm.dateRange = dateRange 
      this.selectRange = dateRange
    },
    removeOrderSelected() {
      this.filterForm.ministryIds = []
    },
    clickSelectUser() {
      this.openTree = !this.openTree
    },
    handleSearch: function (val) {
      if (val) {
        if (!this.allOpened) {
          this.lastOpen = this.open;
          this.allOpened = true;
          this.$refs.tree.updateAll(true);
        }
      } else {
        this.$refs.tree.updateAll(false);
        this.allOpened = false;
        this.open = this.lastOpen;
      }
    },
  },
}
</script>
<style scoped>
.v-expansion-panels {
  position: sticky;
  top: 0;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: darkgray;
}
/deep/.v-expansion-panel-header {
  text-align: left;
  font-weight: 600;
}
.icon-clear-all {
  position: absolute;
  right: 15px;
  top: 20px;
  background: white;
}
.tree-user-selected {
  height: 34px;
  overflow-y: auto;
  border-bottom: 1px solid #d2d2d2;
}
.tree-view-wrapper {
  max-height: 350px;
  overflow-y: auto;
}
/deep/.v-subheader.theme--light {
  width: 100%;
  background: rgb(206, 150, 104);
}
.tree-user-selected span {
  background: darkgrey;
  color: #fff;
  padding: 1px 2px;
  margin-right: 5px;
  position: relative;
  top: 2px;
}
</style>
